import * as React from "react";
import { cva } from "class-variance-authority";

import { cn } from "@/lib/cn";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const textareaVariants = cva(
  "flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm  placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      hasError: {
        true: "border-destructive focus-visible:outline-destructive",
        false: "",
      },
    },
    defaultVariants: {
      hasError: false,
    },
  },
);

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return <textarea className={cn(textareaVariants({ className }))} ref={ref} {...props} />;
});
Textarea.displayName = "Textarea";

export { Textarea };
